module.exports = __webpack_public_path__ + "static/img/nav_bg.f44f2d10.png";